import { createFileRoute } from '@tanstack/react-router'
import { ManageUsers } from 'pages/manageUsers/ManageUsers'
import { usersSearchParams } from 'routes/users/-searchParams'

const RouteComponent = () => {
  const { orgId } = Route.useSearch()

  return <ManageUsers orgId={orgId} />
}

export const Route = createFileRoute('/users/')({
  component: RouteComponent,
  validateSearch: usersSearchParams,
  staticData: {
    title: 'Manage Users',
  },
})
